module.exports = __webpack_public_path__ + "static/img/gc_classic.34c3c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/giftc/gc_classic.png
// module id = 302
// module chunks = 1